import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, takeUntil, startWith, distinctUntilChanged } from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import 'moment/locale/it';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../services/utils.service';

import { AlgConsensoService, REQUEST_STATUS_CANCELED, REQUEST_STATUS_INVALID, REQUEST_STATUS_OK } from '../../services/alg-consenso.service';
import { LocationStrategy } from '@angular/common';
import { ModalitaPagamento, PaymentMethodRequestType, RequestType } from '../../models/fisso';

@Component({
  selector: 'app-payment-method',
  templateUrl: './alg-payment-method.component.html',
  styleUrls: ['./alg-payment-method.component.scss'],
})
export class AlgPaymentMethodComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  public isConsentsOk: boolean;
  public isThirdPartyRequest: boolean;
  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };

  public successStepTexts: string[] = ['PAYMENT_METHOD_SUCCESS_STEP_1', 'PAYMENT_METHOD_SUCCESS_STEP_2', 'PAYMENT_METHOD_SUCCESS_STEP_3'];
  public product: any;
  public isLight: boolean;
  public isGas: boolean;
  public isConsents: boolean;
  public idRichiesta: string;
  public paymentMethodRequest: ModalitaPagamento = {} as ModalitaPagamento;
  public creationDateOfRequest: any;
  public paymentMethodRequestType: PaymentMethodRequestType;

  RequestType = RequestType;
  PaymentMethodRequestType = PaymentMethodRequestType;
  private ngUnsubscribe = new Subject<void>();

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;
  public isErrorInvalidOffer$: Observable<boolean>;

  public checkboxGeneralCondition = {
    checkboxConsents: false,
  };

  // TEXT PART

  public consentsWithAdditionalProperty: any;
  public isProductGasVulnerable: boolean;
  public isVulnerabilityTypeDisability: boolean;
  public consentAccepted = false;

  private _id: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy
  ) {}

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.idRichiesta = params.id;
    });

    this.paymentMethodRequest.requestId = this.idRichiesta;

    this.consensoService.fetchPaymentMethodRequest(this.idRichiesta);

    this.isRequestOk$ = this.consensoService.paymentMethodRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorGeneric$ = this.consensoService.paymentMethodRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );
    this.isErrorInvalidOffer$ = this.consensoService.paymentMethodRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_CANCELED),
      startWith(false),
      distinctUntilChanged()
    );

    this.consensoService.paymentConsentSubject$.subscribe((isChecked) => {
      this.consentAccepted = isChecked;
    });

    this.consensoService.paymentMethodRequest$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((request) => {
      if (!request) return;
      this.paymentMethodRequest = request;
      this.isThirdPartyRequest = this.paymentMethodRequest.thirdPartyIbanHolder !== 'No';
    });

    // mock
    // this.paymentMethodRequest = MOCK_LIST[0];
    // this.isThirdPartyRequest = this.paymentMethodRequest.thirdPartyIbanHolder !== "No"

    this.consensoService.isOtpPaymentMethodRequest$.subscribe((value) => {
      this.isConsents = value;
    });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public getTitle() {
    switch (this.paymentMethodRequest.requestType) {
      case RequestType.monoLight:
        return 'TITLE_PAYMENT_METHOD_MONO_LIGHT';
      case RequestType.monoGas:
        return 'TITLE_PAYMENT_METHOD_MONO_GAS';
      case RequestType.dual:
        return 'TITLE_PAYMENT_METHOD_DUAL';
      default:
        return 'TITLE_PAYMENT_METHOD_GENERIC';
    }
  }

  public getPaymentMethodBody() {
    switch (this.paymentMethodRequest.paymentMethod) {
      case PaymentMethodRequestType.bollettino:
        return 'Bollettino Postale';
      case PaymentMethodRequestType.libretto:
        return `Cessione del credito a Coop Alleanza 3.0 Società Cooperativa per il pagamento delle fatture Libretto nr ${this.paymentMethodRequest.bookletNumber} intestato al Cliente come sopra identificato.`;
      case PaymentMethodRequestType.sepa:
        if (this.isThirdPartyRequest) {
          return `SEPA Direct Debit - Autorizzazione Permanente di Addebito in Conto Corrente con Codice IBAN ${this.paymentMethodRequest.iban} intestato al terzo come indicato nel modulo “Richiesta addebito RID titolare del conto corrente diverso dal titolare della fornitura".`;
        } else {
          return `SEPA Direct Debit - Autorizzazione Permanente di Addebito in Conto Corrente con Codice IBAN ${this.paymentMethodRequest.iban} intestato al Cliente come sopra identificato.`;
        }
      default:
        return '';
    }
  }

  public getAssetList() {
    let assetList = null;

    if (this.paymentMethodRequest.modifiedAsset && this.paymentMethodRequest.modifiedAsset.trim()) {
      if (this.paymentMethodRequest.modifiedAsset.endsWith(';')) {
        this.paymentMethodRequest.modifiedAsset = this.paymentMethodRequest.modifiedAsset.slice(0, -1);
      }
      const assetArray = this.paymentMethodRequest.modifiedAsset.split(';');
      if (assetArray && assetArray.length > 0) {
        assetList = assetArray.map((num) => `<p>nr fornitura: ${num.trim()}</p>`).join('');
      }
    }
    return assetList;
  }

  public openOTPmodal() {
    if (!this.consentAccepted) return;
    this.utils.disableOverflow();
    this.consentsWithAdditionalProperty = {
      requestId: this.paymentMethodRequest.requestId,
      requestCode: this.paymentMethodRequest.requestCode,
      requestType: this.paymentMethodRequest.requestType,
      Alg_OTPCheck__c: false,
      Alg_OTPCheckDate__c: '',
      Alg_OTPPhone__c: '',
    };
    this.isConsentsOk = true;

    this.modalDialogService.openDialog(this.viewContainer, {
      title: 'Un ultimo passo: verifica il tuo numero di cellulare',
      childComponent: AlgOtpModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline textCenter',
      },
      data: {
        isConsentsOk: this.isConsentsOk,
        consents: this.consentsWithAdditionalProperty,
        phone: this.paymentMethodRequest.phone,
        linear: false,
        consensoType: 'payment_method_request',
      },
    });
  }
}

// Mock
const MOCK_LIST: ModalitaPagamento[] = [
  // CASO 1
  {
    requestId: 'REQ12345',
    requestCode: 'RC001',
    phone: '1234567890',
    email: 'new.email@example.com',
    pec: null,
    address: null,
    modifiedAsset: 'Asset002',
    customerCode: 'CUST123',
    fiscalCode: 'FSC1234567890',
    FirstName: 'Mario',
    LastName: 'Rossi',
    paymentMethod: PaymentMethodRequestType.libretto,
    bookletNumber: '1234567890',
    iban: 'IT12345678901234567890',
    sepaBank: 'sepaBank001',
    thirdPartyIbanHolder: 'Third Party Iban Holder',
    subscriberFullName: 'Mario Rossi',
    subscriberTaxCode: 'FSC1234567890',
    oldPaymentMethod: PaymentMethodRequestType.bollettino,
    oldBookletNumber: '1234567890',
    oldIban: 'IT12345678901234567890',
    oldThirdPartyIbanHolder: 'Third Party Iban Holder',
    oldSubscriberFullName: 'Mario Rossi',
    oldSubscriberTaxCode: 'FSC1234567890',
    requestType: RequestType.dual,
    coopCode: '1234567890',
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/alg-payment-method/alg-payment-method.component.ts